$(document).on("turbolinks:load", function() {
  if ( document.querySelector('body.companies.index') ) {
    $('form[id^=edit_user_]').change(function() {
      Rails.fire(this.form, 'submit');
    });
  }
});
